import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import SideBar from "./component/SideBar";
import Login from "./component/Login";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/Dashboard" element={<SideBar />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
